import { PaymentMethodName } from "@/redux/services/pos/pos.type";
import { cn } from "@/lib/utils";
import { Banknote, CreditCard, Smartphone } from "lucide-react";

interface PaymentMethodGridProps {
  selectedMethod: PaymentMethodName | null;
  onSelect: (method: PaymentMethodName) => void;
}

const methods: {
  value: PaymentMethodName;
  label: string;
  icon: React.ReactNode;
}[] = [
  {
    value: "cash",
    label: "Espèces",
    icon: <Banknote className="h-5 w-5" />,
  },
  {
    value: "card",
    label: "Carte",
    icon: <CreditCard className="h-5 w-5" />,
  },
  {
    value: "mobile money",
    label: "Mobile Money",
    icon: <Smartphone className="h-5 w-5" />,
  },
];

const PaymentMethodGrid: React.FC<PaymentMethodGridProps> = ({
  selectedMethod,
  onSelect,
}) => {
  return (
    <div className="flex gap-3">
      {methods.map((method) => {
        const isSelected = selectedMethod === method.value;
        return (
          <button
            key={method.value}
            type="button"
            onClick={() => onSelect(method.value)}
            className={cn(
              "flex-1 flex items-center justify-center gap-2 py-2.5 rounded-lg border text-sm font-medium transition-colors",
              isSelected
                ? "bg-primary/10 text-primary border-primary"
                : "bg-card text-card-foreground border-border hover:bg-muted"
            )}
          >
            {method.icon}
            {method.label}
          </button>
        );
      })}
    </div>
  );
};

export default PaymentMethodGrid;
